import styles from "styles/components/alignCenter.module.scss";

const AlignCenter = ({ children }) => (
  <div className={styles.wrapper}>{children}</div>
);

export default AlignCenter;
